/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import ReactModal from 'react-modal';
import compose from 'lodash/fp/compose';
import { COMMONS as dict } from '../../../../utils/dictionarykeys';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import scrollBlocker from '../../../../utils/scrollBlocker';
import { showElementCss } from '../../../../utils/responsive';
import { MediaQueries } from '../../../../styles/Grid';
import * as styles from './index.styles';
import * as commonStyles from '../index.styles';

const defaultData = {
  body: () => {},
  customStyles: {},
  footer: null,
  header: null,
  isSidePanelOpen: false,
  onRequestClose: () => {},
  toggleSidePanel: () => {},
};

// Modal setup. For more info check https://github.com/reactjs/react-modal
// The if statement is needed due an issue with the tests. Check https://github.com/reactjs/react-modal/issues/632
if (process.env.NODE_ENV !== 'test' && typeof document !== 'undefined') {
  ReactModal.setAppElement(document.getElementById('root'));
}

// TODO: component should be moved as UI component
export class SidePanel extends SafePureComponent {
  onAfterOpen = () => {
    scrollBlocker.enable();
  };

  onAfterClose = () => {
    scrollBlocker.disable();
  };

  safeRender() {
    const {
      body,
      bodyCss,
      customStyles,
      footer,
      header,
      headerCss,
      isSidePanelOpen,
      onRequestClose,
      t,
      toggleSidePanel,
    } = this.props;

    return (
      <ReactModal
        isOpen={isSidePanelOpen}
        onAfterClose={this.onAfterClose}
        onAfterOpen={this.onAfterOpen}
        onRequestClose={onRequestClose}
        style={{
          content: styles.contentStyles,
          overlay: styles.overlayStyles,
        }}
      >
        <div
          css={[
            commonStyles.sidePanelSpacing,
            styles.sidePanel,
            footer && styles.sidePanelNarrow,
            customStyles,
          ]}
        >
          <button onClick={toggleSidePanel} css={styles.closeButton}>
            <i css={styles.closeIcon} className="icon-closer" />
            <span
              css={[
                styles.closeText,
                showElementCss(MediaQueries.sm, 'inline'),
              ]}
            >
              {t(dict.CLOSE)}
            </span>
          </button>
          {header && (
            <div css={[styles.headerWrapper, headerCss]}>{header()}</div>
          )}
          <div css={[styles.bodyWrapper, bodyCss]}>
            <div>{body()}</div>
          </div>
        </div>
        {footer && (
          <footer css={[commonStyles.sidePanelSpacing, styles.footer]}>
            {footer()}
          </footer>
        )}
      </ReactModal>
    );
  }
}

SidePanel.displayName = 'SidePanel';

SidePanel.defaultProps = {
  ...defaultData,
  t: key => key,
};

SidePanel.propTypes = {
  body: PropTypes.func,
  customStyles: PropTypes.object,
  footer: PropTypes.func,
  header: PropTypes.func,
  isSidePanelOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  stickyContent: PropTypes.func,
  toggleSidePanel: PropTypes.func,
};

export default compose(withNamespaces())(SidePanel);
